/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import SideMenuComponent from "./SideMenu";
import TopHeader from "./TopHeader";
import BreadcrumbWrapper from "./BreadcrumbWrapper";

import {
  FileTextOutlined,
  CreditCardOutlined,
  PieChartOutlined,
  ApartmentOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import "./index.css";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import { useCommonStore } from '@/store';

const { Content } = Layout;

export default function NewsSandBox({}) {
  const sideMenuRef = useRef(null);
  const [menuItems, setMenuItems] = useState([]);
  const [currentMenu, setCurrentMenu] = useState(localStorage.getItem('currentMenu') || '' ); 
  const showMenu = () => {
    if (sideMenuRef.current) {
      sideMenuRef.current.changeMenu(); // 调用子组件的方法
    }
  };

  const iconFn = (key) => {
    const iconMatch = {
      CreditCardOutlined: <CreditCardOutlined />,
      FileTextOutlined: <FileTextOutlined />,
      PieChartOutlined: <PieChartOutlined />,
      ApartmentOutlined: <ApartmentOutlined />,
      TeamOutlined: <TeamOutlined />,
    };
    return iconMatch[key] || <TeamOutlined />;
  }

  const handleMenuFn = (menuList) => {
    const list = menuList.map(item => ({
        ...item,
        icon: iconFn(item.menuIcon),
    }))
    setMenuItems(list);
  } 
  //  const handleMenuSelect = (menuText) => {
  //   setCurrentMenu(menuText);
  //     localStorage.setItem('currentMenu', menuText);
  //     console.log("menuText",menuText);
  // };
const handleMenuSelect = (menuText) => {
  setCurrentMenu(menuText);
};

  const refreshKey = useCommonStore((state) => state.sideMenuRefreshKey);

  useEffect(() => {
    const menuList = JSON.parse(localStorage.getItem("menuList")) || [];
    handleMenuFn(menuList)
  }, [refreshKey]);
  
  return (
 <Layout className="app-layout">
      <SideMenuComponent
        menuItems={menuItems}
        ref={sideMenuRef}
        onMenuSelect={handleMenuSelect}
      />
      <Layout className="app-main">
        <TopHeader showMenu={showMenu} currentMenu={currentMenu} />
        <BreadcrumbWrapper />
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}


